<template>
    <div>
    <div class="flex bg-white border-b border-gray-200 fixed top-0 inset-x-0 z-10 h-16 items-center">
      <div class="w-full max-w-screen-xl relative mx-auto px-6 container">
        <div class="flex items-center -mx-6">
          <div class="lg:w-1/4 xl:w-1/5 pl-6 pr-6 lg:pr-8">
            <div class="flex items-center">
              <h1 class="block lg:mr-4 text-xl text-blue-500 font-bold">
                Aerobile
              </h1>
            </div>
          </div>

          <div class="flex flex-grow lg:w-3/4 xl:w-4/5">


            <div class="w-full lg:px-6 xl:w-3/4 xl:px-12">
            </div>


            <div class="flex items-center justify-between xl:w-1/4 px-6">
              <div class="relative mr-4">
              </div>
              <div class="flex justify-start items-center text-gray-500">
                <button v-if="isManager"
                        type="button"
                        class="mr-5"
                        title="Account Setting"
                        @click="openModalForPasswordManager">
                    <i class="material-icons">
                        account_circle
                    </i>
                </button>
                <router-link to="/login" class="mr-5"  title="Exit">
                    <i class="material-icons">
                        exit_to_app
                    </i>
                </router-link>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="w-full flex relative mx-auto container">

        <div id="sidebar"
            class="h-full bg-white w-full border-b -mb-16 lg:-mb-0 lg:static lg:h-auto lg:overflow-y-visible lg:border-b-0 lg:w-2/12 lg:block lg:border-0 xl:w-2/12">
            <div id="navWrapper" class="h-full overflow-y-auto scrolling-touch lg:h-auto lg:block lg:relative lg:sticky lg:top-16 bg-white lg:bg-transparent">
                <nav class="px-3 pt-24">
                    <div class="mb-10">
                        <router-link to="/simcards" class="mt-3 lg:mt-1 flex items-center px-2 -mx-2 py-1 hover:text-gray-900 font-medium text-gray-600">
                            <i class="material-icons">
                                sim_card
                            </i>
                            <span class="ml-3">Simcard List</span>
                        </router-link>
                        <router-link v-if="isManager" to="/tags" class="mt-3 lg:mt-1 flex items-center px-2 -mx-2 py-1 hover:text-gray-900 font-medium text-gray-600">
                            <i class="material-icons">
                                label
                            </i>
                            <span class="ml-3">Manage Tags</span>
                        </router-link>
                        <router-link v-if="isManager"
                            to="/act-requests" class="mt-3 lg:mt-1 flex items-center px-2 -mx-2 py-1 hover:text-gray-900 font-medium text-gray-600">
                            <i class="material-icons">
                                cloud_upload
                            </i>
                            <span class="ml-3">Batch Activation</span>
                        </router-link>
                        <router-link to="/cookie-policy" class="mt-3 lg:mt-1 flex items-center px-2 -mx-2 py-1 hover:text-gray-900 font-medium text-gray-600">
                            <i class="material-icons">
                                policy
                            </i>
                            <span class="ml-3">Cookie Policy</span>
                        </router-link>
                    </div>
                    <div class="bg-gray-100 text-xs text-gray-600 px-2 py-2">
                        <p class="text-sm">This website uses cookies to improve the website and user experience. By continuing to use the site and do not change the cookie settings of the browser, you agree to our <router-link to="/cookie-policy" class="underline">cookie policy</router-link>. © 2020 Aerobile LLC</p>
                    </div>
                </nav>
            </div>
        </div>

        <div id="content-wrapper" class="min-h-screen w-full lg:static lg:max-h-full lg:overflow-visible lg:w-10/12 xl:w-10/12 ">
            <div>
                <div class="flex">
                    <div class="pt-24 pb-16 w-full">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>

      </div>

      <PasswordManager/>

    </div>
</template>

<script>
import {
    mapState,
    mapActions
} from 'vuex'
import PasswordManager from './PasswordManager.vue';

export default {

    components: {
        PasswordManager,
    },

    computed: {
        ...mapState(
            'auth',
            [
                'isManager'
            ]
        ),
    },

    methods:{
        ...mapActions(
            'passwordManager',
            [
                'openModal',
            ]
        ),

        openModalForPasswordManager(){
            this.openModal();
        }
    }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
